import { Types } from './types'

const initialState = {
    dataAllCategory: [],
    dataDetail: {},
    dataAllSpecifications: [],
    dataAllProperties: [],
    dataListProductVariant: [],
    dataAllTag: [],
    dataListSpecifications: {
        rows: [],
        total: 0
    },
    dataListCategory: {
        rows: [],
        total: 0
    },
    dataListProduce: {
        rows: [],
        total: 0
    },
    dataListProperty: { 
        rows: [],
        total: 0
    },
    dataListTagProduct: {
        rows: [],
        total: 0
    },
    dataListProductVariantProp: []
}
const reducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case Types.SAVE_LIST_ALL_CATEGORY:
            return {
                ...newState,
                dataAllCategory: action.payload
            }
        case Types.SAVE_LIST_SPECIFICATIONS:
            return {
                ...newState,
                dataListSpecifications: action.payload
            }
        case Types.SAVE_ALL_SPECIFICATIONS:
            return {
                ...newState,
                dataAllSpecifications: action.payload
            }
        case Types.SAVE_LIST_CATEGORY:
            return {
                ...newState,
                dataListCategory: action.payload
            }
        case Types.SAVE_LIST_ALL_PRODUCE:
            return {
                ...newState,
                dataListProduce: action.payload
            }
        case Types.SAVE_DETAIL_PRODUCE:
            return {
                ...newState,
                dataDetail: action.payload
            }
        case Types.SAVE_ALL_PROPERTIES:
            return {
                ...newState,
                dataAllProperties: action.payload
            }
        case Types.SAVE_ALL_TAG:
            return {
                ...newState,
                dataAllTag: action.payload
            }
        case Types.SAVE_LIST_PROPERTY: 
            return {
                ...newState,
                dataListProperty: action.payload
        }
        case Types.SAVE_LIST_TAG_PRODUCT:
            return {
                ...newState,
                dataListTagProduct: action.payload
            }
        case Types.SAVE_LIST_PRODUCT_VARIANT:
            return {
                ...newState,
                dataListProductVariant: action.payload
            }
        case Types.SAVE_LIST_PRODUCT_VARIANT_PROP:
            return {
                ...newState,
                dataListProductVariantProp: action.payload
            }
        default:
            return { ...newState }
    }
}
export default reducer
